import React from 'react';
import { Slide } from './Slide';
import { SlideControl } from './SlideControl';

export class Slider extends React.Component {
    constructor(props) {
        super(props);

        //todo: move away from flexslider and make own implementation

        this.slides = this.props.children.map((slide) =>
            <Slide key={slide.props.id}
                id={slide.props.id}
            >
                {slide}
            </Slide>
        );

        this.embedCSS = this.props.embeddedCSS ? <style>{this.props.embeddedCSS}</style> : null;
    }

    componentDidMount() {
        $j(`${this.props.parentSelector}`).flexslider({
            animation: "fade",
            animationDuration: 99999999999,
            directionNav: false
        });
    }

    render() {
        return (
            <React.Fragment>
                {this.embedCSS}
                <ul className="slides">
                    {this.slides}
                </ul>
            </React.Fragment>
        );
    }
}